<template>
    <div>
        <b-card>
          <div slot="header">
            {{company.name ? company.name : "Nytt företag"}}
          </div>
          <b-tabs>
            <b-tab active>
                <template slot="title">
                    <span :class="{'text-danger': $v.validationGroup_Information.$anyError }">Information</span>
                </template>
          
                <b-form-group>
                    <label for="company">Namn</label>
                    <b-form-input type="text" id="company"
                      v-model.trim="$v.company.name.$model"
                      class="col-lg-5 col-md-6 col-sm-7"
                      :class="{ 'is-invalid': $v.company.name.$anyError}">
                    </b-form-input>
                    <b-form-invalid-feedback>
                      Detta fält är obligatoriskt
                    </b-form-invalid-feedback>  
                </b-form-group>

                <b-form-group>
                    <label for="lightlogotype">Ljus logotyp</label>
                    <b-form-file id="lightlogotype" 
                      @change="onLightLogotypeSelected"
                      placeholder="Välj en fil för ljus logotyp..." 
                      drop-placeholder="Droppa en fil här..."/>
                    <label class="text-danger mt-1">{{lightLogotypeError}}</label>
                    <div style="background-color:#2f353a" class="mt-1" v-if="company.lightLogo">
                      <img v-bind:src="company.lightLogo" style="height:50px;" class="ml-2 mt-2 mb-2"  />
                    </div>
                </b-form-group>

                <b-form-group>
                    <label for="lightlogotype">Mörk logotyp</label>
                    <b-form-file id="darklogotype" 
                      @change="onDarkLogotypeSelected"
                      placeholder="Välj en fil för mörk logotyp..." 
                      drop-placeholder="Droppa en fil här..."/>
                    <label class="text-danger mt-1">{{darkLogotypeError}}</label>
                    <div style="background-color:#eee" class="mt-1" v-if="company.darkLogo">
                      <img v-bind:src="company.darkLogo" style="height:50px;" class="ml-2 mt-2 mb-2"  />
                    </div>
                </b-form-group>
                <b-form-group>
                    <label for="bankgiroCustomerId">Kundnummer bankgiro</label>
                    <b-form-input type="text" 
                      class="col-lg-4 col-md-5 col-sm-6 col-7"
                      id="bankgiroCustomerId"
                      :class="{ 'is-invalid': $v.company.bankgiroCustomerId.$anyError}"
                      v-model.trim="$v.company.bankgiroCustomerId.$model">
                    </b-form-input>
                    <b-form-invalid-feedback>
                      Felaktigt kundnummer
                    </b-form-invalid-feedback>  
                </b-form-group>   
                <b-form-group>
                    <label for="bankgiroNumber">Bankgironummer</label>
                    <b-form-input 
                      class="col-lg-4 col-md-5 col-sm-6 col-7"
                      id="bankgiroNumber"
                      name="bankgiroNumber"
                      :class="{ 'is-invalid': $v.company.bankgiroNumber.$anyError}"
                      v-model.trim="$v.company.bankgiroNumber.$model"></b-form-input>
                </b-form-group>
                <b-form-invalid-feedback>
                  Ogiltigt bankgironummer
                </b-form-invalid-feedback>                             
            </b-tab>
            <b-tab>
                <template slot="title">
                    <span>Import</span>
                </template>
                <b-form-group>
                    <label for="importuserid">Import användar id</label>
                    <b-form-input type="text" id="importuserid"
                        class="col-lg-5 col-md-6 col-sm-7"
                        v-model="company.importAuthenticationProviderAccountId"></b-form-input>
                </b-form-group>

                <b-form-group>
                    <label for="importusertoken">Import autentiseringstoken</label>
                    <b-form-input type="text" id="importusertoken" 
                        v-model="company.importAuthenticationProviderToken"></b-form-input>
                </b-form-group>
            </b-tab>
            <b-tab>
              <template slot="title">
                <span :class="{'text-danger': $v.validationGroup_Calculation.$anyError }">Beräkningar</span>                
              </template>
              <b-form-group>
                  <label for="expensesLoadedUntilDayDate">Utgifter sista beräkningsdag</label>
                  <b-form-input type="number" 
                    class="col-lg-1 col-md-2 col-sm-3 col-4"
                    id="expensesLoadedUntilDayDate"
                    :class="{ 'is-invalid': $v.company.expensesLoadedUntilDayDate.$anyError}"
                    v-model.number="$v.company.expensesLoadedUntilDayDate.$model"></b-form-input>
              </b-form-group>
              <b-form-invalid-feedback>
                Ogiltigt eller obligatoriskt värde
              </b-form-invalid-feedback>                
            </b-tab>
            <b-tab>
              <template slot="title">
                <span :class="{'text-danger': $v.validationGroup_Salary.$anyError }">Lön</span>
              </template>                          
              <b-form-group>
                  <label for="variableSalaryPaymentMonth">Månader för rörlig lön</label>
                  <b-form-input type="text" 
                    class="col-lg-4 col-md-5 col-sm-6 col-7"
                    id="variableSalaryPaymentMonth"
                    name="variableSalaryPaymentMonth" 
                    :class="{ 'is-invalid': $v.company.variableSalaryPaymentMonth.$anyError}"
                    v-model="$v.company.variableSalaryPaymentMonth.$model"></b-form-input>
              </b-form-group>            
              <b-form-invalid-feedback>
                Ogiltigt värde
              </b-form-invalid-feedback>               
            </b-tab>
            <b-tab>
              <template slot="title">
                <span :class="{'text-danger': $v.validationGroup_SickLeave.$anyError }">Sjukfrånvaro</span>
              </template>
              <b-form-group>
                  <label for="sickLeaveDaysOfPaidSickleave">Antal dagar betald sjuklön</label>
                  <b-form-input type="number" 
                    class="col-lg-1 col-md-2 col-sm-3 col-4"
                    id="sickLeaveDaysOfPaidSickleave"
                    name="sickLeaveDaysOfPaidSickleave" 
                    :class="{ 'is-invalid': $v.company.sickLeaveDaysOfPaidSickleave.$anyError}"
                    v-model.number="$v.company.sickLeaveDaysOfPaidSickleave.$model">
                  </b-form-input>
                  <b-form-invalid-feedback>
                    Ogiltigt eller saknat obligatoriskt värde
                  </b-form-invalid-feedback>  
              </b-form-group>
              <b-form-group>
                  <label for="sickLeaveMaxYearlyQualifyingDays">Antal karensdagar/år</label>
                  <b-form-input type="number" 
                    class="col-lg-1 col-md-2 col-sm-3 col-4"
                    id="sickLeaveMaxYearlyQualifyingDays"
                    name="sickLeaveMaxYearlyQualifyingDays" 
                    :class="{ 'is-invalid': $v.company.sickLeaveMaxYearlyQualifyingDays.$anyError}"
                    v-model.number="$v.company.sickLeaveMaxYearlyQualifyingDays.$model">
                  </b-form-input>
                  <b-form-invalid-feedback>
                    Ogiltigt eller saknat obligatoriskt värde
                  </b-form-invalid-feedback>  
              </b-form-group>
              <b-form-group>
                  <label for="sickLeaveMaxPeriodSpace">Antal kalenderdagar för ny karens</label>
                  <b-form-input type="number" 
                    class="col-lg-1 col-md-2 col-sm-3 col-4"
                    id="sickLeaveMaxPeriodSpace"
                    name="sickLeaveMaxPeriodSpace" 
                    :class="{ 'is-invalid': $v.company.sickLeaveMaxPeriodSpace.$anyError}"
                    v-model.number="$v.company.sickLeaveMaxPeriodSpace.$model">
                  </b-form-input>
                  <b-form-invalid-feedback>
                    Ogiltigt eller saknat obligatoriskt värde
                  </b-form-invalid-feedback>  
              </b-form-group>                               
            </b-tab>
           <b-tab>
              <template slot="title">
                <span :class="{'text-danger': $v.validationGroup_Vacation.$anyError }">Semester</span>
              </template>
              <b-form-group>
                  <label for="vacationYearStart">Start semesterår</label>
                  <b-form-input type="number" 
                    class="col-lg-1 col-md-2 col-sm-3 col-4"
                    id="vacationYearStart"
                    name="vacationYearStart"
                    :class="{ 'is-invalid': $v.company.vacationYearStart.$anyError}"
                    v-model.number="$v.company.vacationYearStart.$model">
                  </b-form-input>
                  <b-form-invalid-feedback>
                    Ogiltigt eller saknat obligatoriskt värde
                  </b-form-invalid-feedback>  
                </b-form-group>               
           </b-tab>                      
          </b-tabs>
          <button class="btn btn-primary mt-1" v-on:click="saveCompany()" :disabled="saving" ><b-spinner v-if="saving" class="mr-1" type="border" small />Spara</button>
        </b-card>


    </div>
</template>

<script>
import { required, numeric, between } from 'vuelidate/lib/validators'
import { companyService } from "../../shared/services";
import { globalStore, getBase64 } from "../../shared/helpers";

const bankgiroNumberValidator = (value) => /^\d{3,4}-\d{4}$/.test(value);
const variableSalaryMonthValidator = (value) => {
  if(!value) return true;
  return /^\d+(,\d+)*$/.test(value);
} 

export default {
  data() {
    return {
      company: {
        id: 0,
        name: null,
        bankgiroCustomerId: null,
        bankgiroNumber: null,
        importAuthenticationProviderAccountId: "",
        importAuthenticationProviderToken: "",
        sickLeaveMaxYearlyQualifyingDays: 10,
        sickLeaveDaysOfPaidSickleave: 14,
        sickLeaveMaxPeriodSpace: 5,
        vacationYearStart: 4,
        parentalLeaveAccruForVacation: 120,
        expensesLoadedUntilDayDate: 10,
        variableSalaryPaymentMonth: null
      },
      imageBytes: null,
      lightLogotypeError: null,
      darkLogotypeError: null,
      saving: false
    };
  },
  validations: {
    validationGroup_Information: ['company.name', 'company.bankgiroCustomerId', 'company.bankgiroNumber'],
    validationGroup_Calculation: ['company.expensesLoadedUntilDayDate'],
    validationGroup_Salary: ['company.variableSalaryPaymentMonth'],
    validationGroup_Vacation: ['company.vacationYearStart'],
    validationGroup_SickLeave: ['company.sickLeaveDaysOfPaidSickleave', 'company.sickLeaveMaxYearlyQualifyingDays', 'company.sickLeaveMaxPeriodSpace'],
    company: {
      name: {
        required
      },
      bankgiroCustomerId: {
        numeric
      },
      bankgiroNumber: {
        required,
        bankgiroNumberValidator
      },
      expensesLoadedUntilDayDate: {
        required,
        between: between(1, 28)         
      },
      variableSalaryPaymentMonth: {
        variableSalaryMonthValidator
      },
      sickLeaveDaysOfPaidSickleave: {
        required,
        numeric
      },
      sickLeaveMaxYearlyQualifyingDays: {
        required,
        numeric
      },
      sickLeaveMaxPeriodSpace: {
        required,
        numeric
      },
      vacationYearStart: {
        required,
        between: between(1, 12)   
      }
    }
  },
  mounted() {
    if (this.$route.params.id == 0) return;

    companyService
      .getById(this.$route.params.id)
      .then(p => {
        this.company = p;
      })
      .catch(() =>
        window.toastr.error("Ett okänt fel uppstod när företaget skulle hämtas")
      );
  },
  methods: {
    onLightLogotypeSelected(event) {
      this.lightLogotypeError = null;
          if (event.target.files[0].size > 100000) {
          this.lightLogotypeError = "Logotypen kan inte vara större än 100kB";
          return;
      }
      getBase64(event.target.files[0]).then(p => {
          this.company.lightLogo = p;
      });
    },
    onDarkLogotypeSelected(event) {
        this.darkLogotypeError = null;
        if (event.target.files[0].size > 100000) {
            this.darkLogotypeError = "Logotypen kan inte vara större än 100kB";
            return;
        }
        getBase64(event.target.files[0]).then(p => {
            this.company.darkLogo = p;
        });
    },
    saveCompany() {
        this.$v.company.$touch();
        if(this.$v.company.$anyError) return;

        this.saving = true;
        companyService.save(this.company).then(p => {
          this.saving = false;
          this.company = p;

          this.ShowToast(
            "Sparad",
            "Företagsinformationen sparades",
            "success"
          );

          globalStore.companies = null;
          if (this.$route.params.id == 0) {
              this.$router.push({ path: "/administration/companies" });
          }
      })
      .catch(p => {
          alert(p);
          this.saving = false;
          this.ShowToast(
            "Fel",
            "Ett okänt fel uppstod när företaget skulle sparas",
            "error"
          );
      })
    }
  }
};
</script>

<style>
</style>
